import React, { useState } from "react";
//import { useForm } from "../../../hooks/useForm";
import { ValidatorForm } from "react-material-ui-form-validator";
import { InformacionDocumentacionMedicacion } from "./InformacionDocumentacionMedicacion";

export const DocumentacionMenu = () => {
    const [datosCompletosDocumentacion, setDatosCompletosDocumentacion] = useState(false);

    /*
    const [
      formValues,
      ,
      ,
      setearValor,
      ,
      ,
      ,
      ,
      ,
    ] = useForm(
      solicitudSeleccionada
    );
  
    const {
      fechaInicio = new Date()
    } = formValues;
    */

    const submitHandler = () => {
        //dispatch(setActiveStep(STEPPER_MEDICACION.MEDICAMENTOS));
    };

    return (
        <React.Fragment>
            <ValidatorForm onSubmit={submitHandler}>
                <InformacionDocumentacionMedicacion
                    datosCompletos={datosCompletosDocumentacion}
                    setDatosCompletos={setDatosCompletosDocumentacion}
                />

            </ValidatorForm>
        </React.Fragment>
    );
};
